<template>
  <div class="input-group">
    <span class="input-group-text"><font-awesome-icon :icon="['fas', 'tag']" /></span>
    <select id="labelTemplate" name="labelTemplate" class="form-select" v-model="selectedTemplateId" required>
      <option v-for="template in selectList" :key="template.id" :value="template.id">{{ template.code }}</option>
    </select>
  </div>
</template>

<script setup lang="ts">

import LabelTemplate from "@/models/frontend/LabelTemplate";
import { useLabelTemplatesStore } from "@/stores";
import { computed, onMounted, ref, watch } from "vue";

const labelTemplateStore = useLabelTemplatesStore();

const templates = ref<LabelTemplate[]>([])
const selectedTemplateId = ref('') // this is a string, as the select element returns it as string

const props = defineProps({
  predefinedTemplateId: { type: Number, required: false },
  allowEmpty: { type: Boolean, required: false }
})
const emit = defineEmits<{ (e: 'templateSelected', template: LabelTemplate | undefined): void }>();

const selectList = computed(() => {
  if (props.allowEmpty) {
    return [{}, ...templates.value] as LabelTemplate[];
  }

  return templates.value;
});

watch(() => props.predefinedTemplateId, async (newTemplateId: number | undefined) => {
  if (templates.value.length == 0) return; // mounting not done yet, let the change be handled by onMounted once the data is loaded

  if (newTemplateId || props.allowEmpty) {
    selectedTemplateId.value = String(newTemplateId);
  }
});

watch(() => selectedTemplateId.value, async (newTemplateId: string) => {
  const newTemplate = templates.value.find(x => x.id == Number.parseInt(newTemplateId));
  emit('templateSelected', newTemplate);
});

onMounted(async () => {
  templates.value = labelTemplateStore.getAll();
  if (props.predefinedTemplateId) {
    selectedTemplateId.value = String(props.predefinedTemplateId);
  }

  if (templates.value?.length > 0 && selectedTemplateId.value == '' && !props.allowEmpty) {
    selectedTemplateId.value = String(templates.value[0]!.id);
  }
});
</script>
